module.exports = __webpack_public_path__ + "img/aqmola4.eb7c1b20.jpg";